import React, { useEffect } from "react";
import AppRoutes from "./routes/AppRoutes";
import { useAuth } from "./Context/AuthContext";
import NotificationContainer from "./Components/Notification/NotificationContainer";
import IdleTimeoutModal from "./Components/IdleTimeoutModal";

function App() {
  const { loading } = useAuth();

  // Global background image, every page. Set on document.body (not a CSS file url()) —
  // CRA's css-loader resolves CSS url() paths as webpack modules relative to src/, which
  // fails for public/ assets; inline/JS-set styles bypass that and resolve at runtime
  // against the public root instead, same as LoginPage.jsx/Register.jsx already do.
  // Tiled + scroll (not cover/fixed): `fixed` anchors to the viewport, so on any page
  // taller than one screen — most of this app's pages — it only ever paints within the
  // first viewport's height and is blank everywhere else. Tiling covers pages of any
  // length; `scroll` (the default) attaches the image to the document instead of the
  // viewport, so it moves with the page rather than staying pinned to one spot.
  useEffect(() => {
    document.body.style.backgroundImage = "url(/assets/img/backgroundImage.webp)";
    document.body.style.backgroundRepeat = "repeat";
    document.body.style.backgroundAttachment = "scroll";
  }, []);

  if (loading) return <div>Loading...</div>;
  return (
    <>
      <AppRoutes />
      <IdleTimeoutModal />
      <NotificationContainer />
    </>
  );
}

export default App;
